import { verify } from './actions';

export default function verifyUser(store) {
  const authStore = store.getState().get('auth');
  if (authStore.isFetching === false && authStore.verifySuccess === false) {
    store.dispatch(verify());
  }
}



// WEBPACK FOOTER //
// ./src/containers/Auth/verifyToken.js